import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

type LoadingProps = {
  fullHeight?: boolean;
  height?: string;
};

const Loading = ({ fullHeight = false, height }: LoadingProps) => {
  return (
    <Stack sx={{ height: fullHeight ? '100vh' : height ? height : 'auto' }} justifyContent='center' alignItems='center'>
      <CircularProgress />
    </Stack>
  );
};

export default Loading;
